import { LinearProgress, Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const RatioMonitor = ({ maxValue, teclasDigitadas }) => {
  const numericValue = Number(maxValue);

  const barColor =
    numericValue >= 80 ? "#81C784" :
    numericValue >= 60 ? "#FFD54F" :
    "#E57373";

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
        <Typography sx={{ fontSize: "0.72rem", fontWeight: 700, color: "#1A3865" }}>
          Aproveitamento
        </Typography>
      </Box>

      <LinearProgress
        variant="determinate"
        value={numericValue}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: "rgba(100, 125, 238, 0.12)",
          "& .MuiLinearProgress-bar": {
            backgroundColor: barColor,
            borderRadius: 4,
          },
        }}
      />

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 0.8 }}>
        <Typography sx={{ fontSize: "0.72rem", fontWeight: 700, color: barColor }}>
          {numericValue}%
        </Typography>
        <Typography sx={{ fontSize: "0.7rem", color: "#6b7a99" }}>
          {teclasDigitadas?.toLocaleString("pt-BR")} {teclasDigitadas === 1 ? "tecla digitada" : "teclas digitadas"}
        </Typography>
      </Box>
    </Box>
  );
};

RatioMonitor.propTypes = {
  maxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  teclasDigitadas: PropTypes.number,
};

export default RatioMonitor;
